export default __webpack_public_path__ + "img/fnnekcVb.e1c01e05.svg";